import React, { createContext, useState, useContext } from 'react';

const STORAGE_KEY = 'llm_cfg';

const DEFAULT_CONFIG = {
  enabled: true,
  enable_precheck: true,
  enable_postcheck: true,
  enable_pii_check: true,
  enable_prompt_injection_check: true,
  pii_score_threshold: 0.65,
  injection_score_threshold: 0.75,
};

function loadConfig() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return { ...DEFAULT_CONFIG, ...JSON.parse(stored) };
  } catch (_) {}
  return DEFAULT_CONFIG;
}

const LlmConfigContext = createContext();

export const LlmConfigProvider = ({ children }) => {
  const [llmConfig, setLlmConfigState] = useState(loadConfig);

  const setLlmConfig = (updater) => {
    setLlmConfigState((prev) => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (_) {}
      return next;
    });
  };

  return (
    <LlmConfigContext.Provider value={{ llmConfig, setLlmConfig }}>
      {children}
    </LlmConfigContext.Provider>
  );
};

export const useLlmConfig = () => useContext(LlmConfigContext);
